export const parseCheckout = (data) => {
  const products = []
  data.lineItems.edges.forEach(({ node }) => {
    const {
      title,
      site_link: siteLink,
      color,
      size,
      image,
      is_final_sale: isFinalSale,
    } = node.customAttributes.reduce(
      (acc, { key, value }) => {
        if (acc[key] === null) {
          acc[key] = value
        }
        return acc
      },
      {
        title: null,
        color: null,
        size: null,
        image: null,
        site_link: null,
        is_final_sale: null,
      }
    )
    products.push({
      id: node?.variant?.id || null,
      quantity: node?.quantity || null,
      title,
      color,
      size,
      image,
      handle: siteLink,
      price: node?.variant?.price?.amount.toString() || null,
      strikeoutPrice: node?.variant?.compareAtPrice?.amount.toString() || null,
      discountAllocations: node?.discountAllocations || null,
      quantityAvailable: node?.variant?.quantityAvailable || null,
      sku: node?.variant?.sku || null,
      isFinalSale,
    })
  })
  return {
    id: data?.id,
    products,
    totalAmount: data?.totalPrice?.amount.toString() || null,
    subtotalAmount: data?.subtotalPrice?.amount.toString() || null,
    totalTaxAmount: data?.totalTax?.amount.toString() || null,
  }
}
